const defaultTheme = require('tailwindcss/defaultTheme')
const { dashboardTailwindExtensions, screens } = require("./styles/dashboardTailwindExtensions");

const theme = {
  ...dashboardTailwindExtensions,
  screens,
  dashboardTailwindExtensions
};

export { screens };
const { colors: extensionColors } = dashboardTailwindExtensions;
const colors = { ...extensionColors, ...defaultTheme.colors };

export { colors };

export const aux = {
  headerHeight: 64,
  mobile: {
    navbarHeight: 75,
    criticalBannerHeight: 56
  },
  desktop: {
    navbarWidthSm: 48,
    navbarWidthLg: 240
  }
};

export default theme;
